import React,{ Component } from 'react';
import {Col, Row, Card, CardBody, Table } from "reactstrap";
import { Line } from 'react-chartjs-2';
import ReactTable from "react-table";
import { Link } from 'react-router-dom'
import { fuzzySearch } from "../../../../utils/helpers";


class DomainTable extends Component {
    constructor(props) {
        super(props);
    }


    render() {
        const columns = [
            {
                Header: "Domain",
                accessor: "domain",
                filterMethod: fuzzySearch,
                Cell: (props) => {
                    return <div >
                            <Link
                                style={{color: 'black'}}
                                to={{
                                    pathname: '/logging',
                                    state: {
                                        level: 'DEBUG',
                                        site: props.value,
                                        start_date: this.props.selectOpen ? this.props.start_date : null,
                                        end_date: this.props.selectOpen ? this.props.end_date: null,
                                        delta: this.props.delta,
                                        optionsMode: "filter"
                                    }
                                }}
                            >
                                {props.value}
                            </Link>
                        </div>
                }
            },
             {
                Header: "Categories",
                accessor: "categories",
                sortMethod: (a, b) => {
                    if (!a){
                        a = '';
                    }
                    if (!b){
                        b = '';
                    }
                    return Object.values(a).sort().join(', ') > Object.values(b).sort().join(', ') ? 1 : -1;
                  },
                 filterMethod: (filter, row) => {
                    if (row[filter.id]){
                       return Object.values(row[filter.id]).sort().join(', ').toLowerCase().includes(filter.value.toLowerCase())
                    }

                },

                Cell: (props) => {
                    return <div>{ props.value ? Object.values(props.value).sort().join(', ') : ''} </div>
                }
            },
            {
                Header: "Requests Allowed",
                accessor: "allowed",
                filterMethod: fuzzySearch,
                Cell: (props) => {
                    return <div>{props.value}</div>
                }
            },
            {
                Header: "Requests Denied",
                accessor: "denied",
                filterMethod: fuzzySearch,
                Cell: (props) => {
                    return <div>{props.value}</div>
                }
            }
        ];
        return (
            <div>
                {this.props.domains.data &&
                    <ReactTable
                        columns={columns}
                        data={this.props.domains.data}
                        filterable
                        defaultSorted={[{id: "allowed", desc: true}]}
                        defaultPageSize={5}
                        className="-striped -highlight"
                    />
                }
            </div>
        );
    }
}

export default DomainTable;


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/DomainTable.js